<app-dialog
  class="home-tasks-complete-dialog"
  [dialogType]="dialogType"
  [centerActions]="true"
  [hideCloseButton]="true"
  [trackingScreenName]="trackingScreenName"
  [primaryActionText]="'HOME.TASK_LIST.CONGRATULATIONS.ACTION' | translate"
>
  <div class="dialog-content-wrapper">
    <app-icon class="success-icon" [icon]="successIcon"> </app-icon>

    <div class="title">
      {{ 'HOME.TASK_LIST.CONGRATULATIONS.TITLE' | translate }}
    </div>

    <div class="sub-title">
      {{ 'HOME.TASK_LIST.CONGRATULATIONS.SUB_TITLE' | translate }}
    </div>

    <div class="other-tasks">
      <p
        *ngFor="let i of 3 | fill; let position = index"
        class="other-task-text"
      >
        {{
          'HOME.TASK_LIST.CONGRATULATIONS.OTHER_TASK_' + position | translate
        }}
      </p>
    </div>
  </div>
</app-dialog>
